/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DocumentsAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2DocumentHeart from 'DesignSystem/Svgs/Tysiav2DocumentHeart/index'



/** @type {import('Simple/types.js').View} */
export default function DocumentsAction({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileActions/Content/DocumentsAction"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
 type="secondary"
 marginTop={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 title="Documents"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2DocumentHeart
{...childProps}
  viewPath={`${viewPath}/Tysiav2DocumentHeart`}
 width={12}
 height={12}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}